// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"input_searchBar__1lokG","icon":"input_icon__2-g9z","clear":"input_clear__1sMwh"};